import React from 'react';
import { FOOTER_ID } from 'globalConst/const';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'util/index';
import FOOTER from './Footer.const';
import NavigationLink from '../NavigationLink';
import styles from './Footer.styles';
import { withRouter } from 'react-router-dom';
import { isDesktopApp } from 'util/device';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(styles, { name: 'Footer' });
const Footer = ({ navigation, location }) => {
  const classes = useStyles();
  const isOnHome = location.pathname === '/';

  if (isEmpty(navigation)) {
    return null;
  }

  const getNavigationList = (navigationList, navigationType) => {
    let allClasses = classNames(classes.list, classes.primary);
    let itemKey = 'primary';

    if (navigationType === 'secondary') {
      allClasses = classNames(classes.list);
      itemKey = 'secondary';
    }

    if (isDesktopApp() && navigationType === 'primary') {
      navigationList = navigationList.filter((item) => {
        return !isEmpty(item.pageLink) && item.pageLink.slug !== 'juke-app';
      });
    }

    return (
      <ul className={allClasses}>
        {navigationList.map(({ title, pageLink, pageUrl }, index) => (
          <li key={`footer-${itemKey}-${title}-${index}`}>
            <NavigationLink
              data-testid="footer-link"
              className={classes.footerLink}
              source={FOOTER.NAV_SOURCE}
              pageLink={pageLink}
              pageUrl={pageUrl}
              title={title}
            >
              {title}
            </NavigationLink>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <footer id={FOOTER_ID}>
      {isOnHome && (
        <h1 data-testid="proposition-text" className={classes.propositionText}>
          JUKE: Jouw gratis startpunt voor radio, podcasts en non-stop muziek
        </h1>
      )}
      <nav className={classes.footerContainer}>
        {!isEmpty(navigation.primary) && getNavigationList(navigation.primary, 'primary')}
        {!isEmpty(navigation.secondary) && getNavigationList(navigation.secondary, 'secondary')}
      </nav>
    </footer>
  );
};

Footer.defaultProps = {
  navigation: null,
};

Footer.propTypes = {
  navigation: PropTypes.object,
  location: PropTypes.object.isRequired,
};

export default withRouter(Footer);
